import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import store from './store'
import router from './router'
import './assets/js/filters'

// element-ui
import EleUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// reset.css
import './assets/styles/reset.css'

// axios
import axios from './axios'

window.gtaAiWebEnv.configVal = process.env.VUE_APP_TAG //获取环境变量的值;

import metaInfo from 'vue-meta-info'
Vue.use(metaInfo)

//coolies
// import VueCookies from "vue-cookies";
// Vue.use(VueCookies);
// mock
//import "./mock"; // 刚刚手写的mock.js文件

// util
import util from './utils'

// require('./utils/directive/index.js')

import vueMoment from 'vue-moment'

// 视频播放vue-video-player
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

// 视频播放videojs
import Video from 'video.js'
import 'video.js/dist/video-js.css'

import './icons'

// // 页面生成pdf并下载 vue页面转PDF
import htmlToPdf from "./utils/htmlToPdf"
Vue.use(htmlToPdf)

Vue.prototype.$video = Video

// Vue use
// element-ui
Vue.use(EleUI)

Vue.use(vueMoment)

Vue.use(VideoPlayer)

// axios
Vue.prototype.$axios = axios
// util
Vue.prototype.$util = util

// config
Vue.config.productionTip = false
// 将 blockly 可直接使用的 xmlDom 进行 Vue 报错忽略处理
Vue.config.ignoredElements = [
  'xml',
  'category',
  'block',
  'value',
  'shadow',
  'field',
  'sep',
  'mutation',
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

//插件
import plugin from './plugins'
Vue.use(plugin)

new Vue({
  store,
  router,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
}).$mount('#app')
